import { useRecoilValue } from 'recoil'
import dashboardsAtom from '@/pages/Dashboards/dashboards.atom.ts'

const useDashboards = () => {
  const items = useRecoilValue(dashboardsAtom).items

  return { dashboards: items }
}

export default useDashboards
